import React from "react";
import {offeringSummary, incomeAndExpenses, rentRoll, getRentRoll, incomeAndExpensesProforma, proformaRequirements, incomeAndExpensesAsIS} from "./tables";
import {getOfferingSummaryData, getIncomeAndExpenses, getincomeAndExpensesProforma, getProformaRequirementsData, getincomeAndExpensesAsIS} from "./tables";
import BaseTabComponent from "../UnderwritingMultiTenant/tabs-components/BaseTabComponent";
import {addCommasToNumber, percent, formatEmail} from "../../utils";
import dollarFormat from "../../dollar-format";

const baseUrl = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/';

let cloneDeep = require('lodash.clonedeep');

export default class PrintMultiTenant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                offeringSummary: offeringSummary,
                incomeAndExpenses: incomeAndExpenses,
                rentRoll: rentRoll,
                incomeAndExpensesProforma: incomeAndExpensesProforma,
                proformaRequirements : proformaRequirements,
                incomeAndExpensesAsIS : incomeAndExpensesAsIS
            },
        }
    }

     static preloadStaticImages(images) {
        if (!Array.isArray(images) || !images.length || typeof document === 'undefined') return;
        images.forEach(src => {
            if (!src) return;
            if (document.querySelector(`link[rel="preload"][data-static-img="1"][href="${src}"]`)) return;
            try {
                const link = document.createElement('link');
                link.rel = 'preload';
                link.as = 'image';
                link.href = src;
                link.setAttribute('data-static-img', '1');
                document.head.appendChild(link);
            } catch (e) { /* ignore */ }
        });
    }

    async createMap(propertyMapProps) {
        let {default: mapboxgl} = await import('mapbox-gl/dist/mapbox-gl.js');

        mapboxgl.accessToken = 'pk.eyJ1IjoiYW5kcmVlYW1pcmNlYSIsImEiOiJja2lpa25rNzQwYWV0MnNxcGdscDVnbGc3In0.YW3ma8Gr7xlYFsAfLwTL1A';
        let map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [propertyMapProps.longitude, propertyMapProps.latitude],
            zoom: 12,
            minzoom: 12,
            maxzoom: 12,
        });

        let el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = `url(${arc.path.media}marker-star.svg)`;

        new mapboxgl.Marker(el).setLngLat([propertyMapProps.longitude, propertyMapProps.latitude])
            .addTo(map);

        const propertyName = propertyMapProps.name;
        new mapboxgl.Popup()
            .setLngLat([propertyMapProps.longitude, propertyMapProps.latitude])
            .setHTML(propertyName)
            .addTo(map);
    }

    componentDidMount() {
        if (!document.querySelector('#mapboxstyles')) {
            const link = document.createElement('link');
            link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.0.0/mapbox-gl.css?optimize=true';
            link.rel = 'stylesheet';
            link.id = 'mapboxstyles';
            document.head.appendChild(link)
        }
        setTimeout(() => this.createMap(this.props.propertyMapProps), 1000);
        PrintMultiTenant.preloadStaticImages(this.props.staticImages);
    }

    async componentWillReceiveProps(nextProps) {
        const data = cloneDeep(this.state.data);
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(nextProps.tabs);
        data.offeringSummary.rows = getOfferingSummaryData(nextProps.tabs, precomputedValues);
        data.incomeAndExpenses = getIncomeAndExpenses(nextProps.tabs, precomputedValues);
        data.rentRoll = getRentRoll(nextProps.tabs, precomputedValues);
        data.incomeAndExpensesProforma = getincomeAndExpensesProforma(nextProps.tabs, precomputedValues);
        data.proformaRequirements = getProformaRequirementsData(nextProps.tabs, precomputedValues);
        data.incomeAndExpensesAsIS = getincomeAndExpensesAsIS(nextProps.tabs, precomputedValues);

        this.setState({data});
    }

    static renderTable(table) {
        return (
            <div className='table'>
                <div className='title'>{table.name}</div>
                {table.rows ?
                    table.rows.map((row, index) => {
                        return (
                            <div key={index} className={`row${index % 2 !== 0 ? ' white' : ''}`}>
                                <div>{row.label}</div>
                                <div>{row.value}</div>
                            </div>
                        )
                    })
                    : null
                }
            </div>
        );
    }
    componentDidUpdate(prevProps, prevState) {
        const { pageNo } = this.props;
        if (pageNo === 3 && pageNo !== prevProps.pageNo) {
            const thirdPage = document.getElementById('');
            if (thirdPage) {
                const redBox = document.createElement('');
                redBox.classList.add('red-box');
                thirdPage.appendChild(redBox);
            }
        }
        if (prevProps.staticImages !== this.props.staticImages) {
            PrintMultiTenant.preloadStaticImages(this.props.staticImages);
        }
    }
    static renderTableMatrix(table, tableClassName, allowFooter, isProformaCheck) {
        return (
            <div className={`table ${tableClassName === 'income-expenses' && !isProformaCheck ? 'big-margin ' : ''}${tableClassName}`}>
                {table.header ?
                    <div className='row table-header'>
                        {table.header.map((cell, index) => {
                            return (
                                <div key={index} className='cell first-letter'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.rows.map((row, index) => {
                    return (
                        <div key={index} className={`row${index % 2 !== 0 ? ' white' : ''} ${table.rows.length - 1 === index ? 'last-row' : ''}`}>
                            {row.valueCells.map((cell, cellIndex) => {
                                return (
                                    <div key={`${index}-${cellIndex}`} className='cell'>{cell.value}</div>
                                )
                            })}
                        </div>
                    )
                })}
                {(table.footer && tableClassName === 'rent-roll' && (table.rows.length < 9 || allowFooter)) || (table.footer && tableClassName === 'income-expenses')  ?
                    <div className={`${tableClassName === 'rent-roll' ? 'column' : 'row'} table-footer`}>
                        {table.footer.map((elem, index) => {
                            if (Array.isArray(elem)) {
                                return (
                                    <div key={index} className='row'>
                                        {elem.map((cell, cellIndex) => {
                                            return (
                                                <div key={`${index}-${cellIndex}`} className='cell'>{cell}</div>
                                            )
                                        })}
                                    </div>
                                )
                            }
                            return (
                                <div key={index} className={`cell ${index === 0 ? 'first-letter' : 'value'}`}>{elem}</div>
                            )
                        })}
                    </div>
                    : null
                }
            </div>
        )
    }

    static renderContent(pageNo, props, data, pagesData = [], index = 0) {
        const isProformaCheck = props.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value == true;
        const name = props.tabs['property-information-tab'].tables['general-information'].rows['property-name'].value;
        const address = props.tabs['property-information-tab'].tables['general-information'].rows['address'].value;
        const city = props.tabs['property-information-tab'].tables['general-information'].rows['city'].value;
        const state = props.tabs['property-information-tab'].tables['general-information'].rows['state'].value;
        const zip = props.tabs['property-information-tab'].tables['general-information'].rows['zip'].value;
        const photo = props.propertyImage ? props.propertyImage.includes('https') ?props.propertyImage : arc.path.media + props.propertyImage : '';
        const PriceRange = '95618a9c4cd78d1bac24d36924993f176f65abfab507514180b0fba80326b1cceca552bc29a5e09d69cf479b2c522155db7aa9a887e1b5b4127795621ae9190b_Pricing_Range_Analysis_Image_2.png';
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(props.tabs);
       
        var aggressive = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['value'].valueCells[1].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
        var anticipated = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['value'].valueCells[2].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
        var conservative = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['value'].valueCells[3].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
        var aggressive_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['cap-rate'].valueCells[1].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
        var anticipated_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['cap-rate'].valueCells[2].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
        var conservative_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix'].rows['cap-rate'].valueCells[3].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
        if(isProformaCheck){
            aggressive = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[1].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
            anticipated = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[2].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
            conservative = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['value'].valueCells[3].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
            aggressive_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['cap-rate'].valueCells[1].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
            anticipated_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['cap-rate'].valueCells[2].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
            conservative_cap = props.tabs['pricing-tab'].tables['pricing-sensitivity-matrix-pro'].rows['cap-rate'].valueCells[3].getComputedValue(props.tabs, precomputedValues).displayValue || '0';
        }
       
        const yearBuilt = props.tabs['marketing-tab'].tables['offering-summary'].rows['year-built'].getComputedValue(props.tabs, precomputedValues).internalValue || '-';
        let noiValue = props.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(props.tabs, precomputedValues).internalValue;
        const noi = noiValue ? (dollarFormat(noiValue)) : '-';
        const lot_size = props.tabs['marketing-tab'].tables['offering-summary'].rows['lot-size'].getComputedValue(props.tabs, precomputedValues).internalValue || '0';
        const Strengths = props.proposalData.strengths || '';
        const challenges = props.proposalData.challenges || '';
        const buyerPool = props.proposalData.buyer_pool || '';
        const qualifications = props.proposalData.qualifications || '';
        const recommendations = props.proposalData.recommendations || '';
        const Occupancy = percent(props.tabs['marketing-tab'].tables['offering-summary'].rows['occupancy'].getComputedValue(props.tabs, precomputedValues).internalValue) || "-";
        const leaseTypes = data.rentRoll.rows || '';
        const analysisDate = props.tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[1].value || 'XX/XX/XXXX';
        let rowCount =0;
        let LeaseCheck = false;
        for(let i=0;i<leaseTypes.length;i++){
            if (leaseTypes[i].valueCells.length>=11){
            if (leaseTypes[i].valueCells[11].value!="NNN"){
                rowCount --
            }else{
                rowCount ++
            }
        }
        }
        if(rowCount ==leaseTypes.length && leaseTypes.length >0 ){
           LeaseCheck = true;
        }

        let photo1Url
        if  (props.isCategoryOffice) {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/Office_image_1.jpg';
        } else if (props.isIndustrialNotVacant || props.isIndustrial) {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/STNL_industrial_vacant_image_1.jpg';
        } else {
            photo1Url = 'https://strivenext.s3.amazonaws.com/website/events/Multi_Tenant_image_1.jpg';
        }
        
        switch (pageNo) {
            case 1:
                return (
                    <div className="page" style={{ height: 'auto', padding: 0 }}>

                        <div className='content' style={{ position: 'relative', padding: 0 }}>
                            <img src={`${photo1Url}`}></img>
                            <div className='bottom-section' style={{ color: 'white', position: 'absolute', left: "6%", bottom: "2%" }}>
                                <div className='address' style={{ fontSize: "25px", lineHeight: "40px" }}>Pricing Analysis  & Marketing Proposal</div>
                                <div className='name' style={{ fontSize: "45px", lineHeight: "40px", fontWeight: "bold" }}>{name}</div>
                                <div className='address' style={{ fontSize: "35px", lineHeight: "40px" }}>{`${city}, ${state}`}</div>
                            </div>
                        </div>
                    </div>
                )
            case 2:
                if (isProformaCheck) {
                    return (
                        <div>
                            <div>
                            <div className='name'>{name}</div>
                                <div className='address'>{address}</div>
                                <div className='address'>{`${city}, ${state} ${zip}`}</div>
                            </div>
                        <div className='content'>
                            <div className='left-container summary-style'>
                                {PrintMultiTenant.renderTable(data.offeringSummary)}
                            </div>
                            <div className='right-container' style={{marginTop: "0px"}}>
                            {PrintMultiTenant.renderTableMatrix(data.proformaRequirements, 'income-expenses proforma', false, isProformaCheck)}
                            </div>
                        </div>
                            <div className='PrintSingleTenant_coverimage'>
                       <img src={photo} alt=''/>
                    </div>
                        </div>
                    );   
                }
                return (
                    <div className='content'>
                        <div className='left-container'>
                            <div className='name'>{name}</div>
                            <div className='address'>{address}</div>
                            <div className='address'>{`${city}, ${state} ${zip}`}</div>
                            {PrintMultiTenant.renderTable(data.offeringSummary)}
                            <div id='map'/>
                        </div>
                        <div className='right-container'>
                            {PrintMultiTenant.renderTableMatrix(data.incomeAndExpenses, 'income-expenses')}
                        </div>
                    </div>
                ); 
            case 4:
                return (
                    <div className="page" style={{ height: 'auto', padding: 0 }}>

                        <div className='content' style={{ position: 'relative', padding: 0 }}>
                            <img src={`https://strivenext.s3.amazonaws.com/website/events/Pricing_Range_Analysis_Image_2.png`}></img>

                            <div className='value-analysis-section'>
                                <div className='conservative' style={{position: "fixed", lineHeight: "10px", textAlign: "center", marginLeft: "205px", width: "180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(conservative)}</p>
                                    <p>{conservative_cap} Cap</p>
                                </div>
                                <div className='anticipated' style={{position: "fixed", lineHeight: "10px",textAlign:"center", marginLeft: "420px", width:"180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(anticipated)}</p>
                                    <p>{anticipated_cap} Cap</p>
                                </div>
                                <div className='aggressive' style={{position: "fixed", lineHeight: "10px", textAlign: "center", marginLeft: "625px", width: "180px", fontFamily: "GothamBook"}}>
                                    <p>${addCommasToNumber(aggressive)}</p>
                                    <p>{aggressive_cap} Cap</p>
                                </div>
                            </div>
                            <div className='value-analysis-section-2' style={{ top: '50%', fontSize: '22px', fontFamily: "Gotham", textAlign: "Center" }}>
                                <div className="yearBuilt" style={{ position: "fixed", marginLeft: "70px", width: "200px", lineHeight: "15px" }}>
                                    <p className='titles'>YEAR BUILT</p>
                                    <p style= {{fontFamily: "GothamBook"}}>{yearBuilt}</p>
                                </div>
                                <div className="noi" style={{ position: "fixed", marginLeft: "308px", width: "200px", lineHeight: "15px" }}>
                                    <p className='titles'>NOI</p>
                                    <p style= {{fontFamily: "GothamBook"}}>{addCommasToNumber(noi)}</p>
                                </div>
                                <div className="lease_types" style={{ position: "fixed", marginLeft: "525px", width: "200px", lineHeight: "15px" }}>
                                    <p className='titles'>{LeaseCheck === true ? "LEASE TYPES" : "OCCUPANCY"}</p>
                                    <p style={{ fontFamily: "GothamBook" }}>{LeaseCheck == true ? "NNN" : Occupancy}</p>
                                </div>
                                <div className="lot_size" style={{ position: "fixed", marginLeft: "760px", width: "200px", lineHeight: "15px" }}>
                                    <p className='titles'>LOT SIZE</p>
                                    <p style= {{fontFamily: "GothamBook"}}>{lot_size} Acres</p>
                                </div>
                            </div>
                            <div className='value-analysis-section-3'>
                                <div className="Strengths">
                                    {Strengths.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)

                                    })}
                                </div>
                                <div className="challenges">
                                    {challenges.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)

                                    })}
                                </div>
                                <div className="buyerPool">
                                    {buyerPool.split('\n').splice(0, 3).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="qualifications">
                                    {qualifications.split('\n').splice(0, 5).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                                <div className="recommendations">
                                    {recommendations.split('\n').splice(0, 2).map(res => {

                                        return (
                                            <ul className="list">
                                                <li>{res}</li>
                                            </ul>)
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return isProformaCheck ?
                (<div className="page" style={{ height: 'auto', padding: 0 }}>
                            {index == 0 ? (
                                <div className="title-container" style={{ color: 'white', fontWeight: 'bold', alignItems: 'start', textAlign: 'start' , display: 'flex', justifyContent: 'start', height: '50px'}}>
                                    <h2 className="title"><span style={{fontSize: '36px'}}>I</span>NCOME & <span style={{fontSize: '36px'}}>E</span>XPENSES</h2>
                                </div>
                            ) : null}
                    <div className='content'>
                            
                        <div style={{width: "47%", marginRight: "20px"}}>
                        {PrintMultiTenant.renderTableMatrix(data.incomeAndExpensesAsIS, 'income-expenses', false, true)}
                        </div>
                        <div style={{width: "52%"}}>
                        {PrintMultiTenant.renderTableMatrix(data.incomeAndExpensesProforma, 'income-expenses', false, true)}
                        </div>
                    </div>
                    </div>) : null;
            default :

                data.rentRoll.rows = data.rentRoll.rows.map(row => {
                    row.valueCells.splice(-2, 1);
                    if (row.valueCells.length < data.rentRoll.header.length) {
                        row.valueCells = row.valueCells.concat(Array(data.rentRoll.header.length - row.valueCells.length).fill({value: "-"}));
                    }
                    return row;
                })
                data.rentRoll.footer = data.rentRoll.footer.map((footer, ind) => {
                    if (ind === 0) {
                        const percentage = parseFloat(footer[3].replace("%", ""));
                        const roundedPercent = Math.round(percentage * 100)/100;
                        const formattedValue = roundedPercent.toFixed(2) + "%";
                        footer[3] = formattedValue;
                    }
                    return footer;
                });
                return (
                    <div className="page" style={{ height: 'auto', padding: 0 }}>
                    <div className='content row'>
                            {index == 0 ? (
                                <div className="title-container" style={{ color: 'white', fontWeight: 'bold', alignItems: 'start', textAlign: 'start' , display: 'flex', justifyContent: 'start', height: '50px'}}>
                                    <h2 className="title"><span style={{fontSize: '36px'}}>R</span>ENT <span style={{fontSize: '36px'}}>R</span>OLL</h2>
                                </div>
                            ) : null}
                        {PrintMultiTenant.renderTableMatrix(data.rentRoll, 'rent-roll', pagesData.length -1 == index)}
                        {pagesData.length -1 == index ? <p style = {{fontSize: "15px"}}>*Analysis Start Date is {analysisDate} and Takes Into Consideration a 1 Year Hold From This Date</p> : null}

                        {props.propertyImage && data.rentRoll.rows.length < 5 ?
                            <div className='property-image'>
                                <img src={photo} alt='' />
                            </div>
                            :
                            null
                        }
                    </div>
                    </div>
                );
             }
    }

    static renderPage(pageNo, props, data, agents, pagesData = [], index = 0) {
        return (
            <div className='page' style={{backgroundImage: `url(${arc.path.media}stnl-background.png)`}}>
                <div className='head'>
                    <div className='logo'>
                        <img src={`${arc.path.media}strive-logo.png`} alt=''/>
                    </div>
                </div>
                {PrintMultiTenant.renderContent(pageNo, props, data, pagesData, index)}
                <div className='footer'>
                    {agents && agents.length ?
                        agents.map(agent => {
                            return (
                                <div key={agent.id}>
                                    <div className='name'>{agent.name}</div>
                                    <div className='details'>
                                        <div>{agent.phone}</div>
                                        <div className={agent.email ? 'line' : ''}/>
                                        <div>{agent.email ? formatEmail(agent.email) : ''}</div>
                                    </div>
                                </div>
                            )
                        }) : null
                    }
                </div>
            </div>
        );
    }

    render() {
        const isProformaCheck = this.props.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value == true;
        const data = this.state.data;
        const agents = this.props.agents;
        const rentRollRows = data.rentRoll.rows || [];
        const rentRollSize = 9;
        const pageCount = Math.ceil(rentRollRows.length / rentRollSize);
        const pagesData = [];

        for (let i = 0; i < pageCount; i++) {
            const start = i * rentRollSize;
            const end = start + rentRollSize;
            pagesData.push({
                ...data,
                rentRoll: {
                    ...data.rentRoll,
                    rows: rentRollRows.slice(start, end)
                }
            });
        }
        return (    
            <div className='PrintMultiTenant'>  
                {PrintMultiTenant.renderContent(1, this.props, data)}
                {PrintMultiTenant.renderPage(2, this.props, data, agents)}
                {isProformaCheck ? PrintMultiTenant.renderPage(3, this.props, data, agents) : null}
                {pagesData.map((pageData, index) => (
                    <React.Fragment key={index}>
                        {PrintMultiTenant.renderPage(index + 5, this.props, pageData, agents, pagesData, index)}
                    </React.Fragment>
                ))}
                {PrintMultiTenant.renderContent(4, this.props, data, agents)}
                {
                    this.props.staticImages.map((img, index) => {
                        return (<React.Fragment key={`${img}-${index}`}>
                        <div className="page" style={{ height: 'auto', padding: 0 }}>
                                <div className='content' style={{ position: 'relative', padding: 0 }}>
                                    <img
                                        className='staticImg'
                                        src={img}
                                        alt=''
                                        loading='eager'
                                        width={960}
                                        height={810}
                                    />
                                </div>
                            </div>
                        </React.Fragment>)
                    })
                }
                
            </div>
        )
    }
}
